module.exports = __webpack_public_path__ + "img/apple-app-store.168c2ce4.svg";